<template>
  <div class="scroller">
    <div
      class="scroller__container"
      ref="scroller-container"
    >
      <div
        class="scroller__main"
        v-bind:style="{ width: `${width}px` }"
        ref="scroller-container-internal"
      >
        <div
          v-for="offset of utcOffsets"
          :key="offset.index"
          class="scroller__utc-offset big-text"
          v-bind:style="{ left: `${(segmentWidth * offset.index)}px` }"
        >
          UTC {{ offset.text }}
        </div>
        <div 
          v-for="stream of streams" 
          :key="stream.id" 
          @mouseover="$emit('setStreamNowViewing',stream.id)"
          @click="$emit('scrollToPageBottom')">

          <ScrollerItem
            :latitude="stream.attributes.latitude"
            :id="stream.id"
            :endTime="endTime"
            :startTime="startTime"
            :stream="stream"
            :width="width"
            :playingId="playingId"
            :playing="playingId == stream.id"
            :selected="selectedId == stream.id"
            :viewing="viewingId == stream.id"
            v-if="!stream.attributes.hidden"
          />
        </div>
      </div>
    </div>
    <div class="scroller__nav big-text">
      <div
        class="scroller__w"
        @mousedown="startScrollW"
        @mouseup="endScroll"
        @mouseleave="endScroll"
      >
        <img src="../assets/2x/arrowleft.png">&nbsp;&nbsp;WEST
      </div>
      <div
        class="scroller__e"
        @mousedown="startScrollE"
        @mouseup="endScroll"
        @mouseleave="endScroll"
      >
        EAST&nbsp;&nbsp;<img src="../assets/2x/badgers.png">
      </div>
      <div class="scroller__reset big-text" v-if="dragged" v-on:click="$emit('resetScrollerPosition')">
        RESET
      </div>
    </div>
  </div>
</template>

<script>
  
import ScrollerItem from '@/components/ScrollerItem';
import ScrollBooster from '@/util/scrollbooster';

import scTime from '@/util/sc_time';

const segmentWidth = 700;
const width = segmentWidth * 27;
const scrollBy = 800;

const utcOffsets = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, -11, -10, -9, -8, -7, -6, -5, -4, -3, -2, -1, 0, 1, 2,
].map((e, i) => ({ index: i, text: (e >= 0) ? `+${e}` : `${e}` }));

export default {
  name: 'Scroller',
  components: {
    ScrollerItem,
  },
  props: ['streams', 'endTime', 'startTime', 'playingId','selectedId','viewingId'],
  data() {
    return {
      dragged: this.dragged,
      utcOffsets,
      segmentWidth,
      width,
      stackedItems: false
    };
  },
  directives: {
  },
  methods: {
    floorToNearest(val,nearest) {
      return Math.floor(val*1.0/nearest)*nearest;
    },
    makeScroll() {
      this.boost = new ScrollBooster({
        direction: 'horizontal',
        emulateScroll: true,
        viewport: this.$refs['scroller-container'],
        scrollMode: 'transform',
        onUpdate: () => { /* click drag*/
          if (this.boost && this.boost.isDragging) {
            this.clearInterval(); 
          }
        },
        onWheel: () => { /* touchpad drag*/
          this.clearInterval();
        },
      });
      this.scrollToTime(false);
    },
    clearInterval() {
      console.log("cleared interval");
      this.dragged = true;
      clearInterval(this.intervalId);
      this.intervalId = -1;
    },
    scrollToTime(scroll = false) {
      if (!this.boost) return;
      if (this.boost.isDragging) return;
      const secsNow = scTime({ startTime: this.startTime, endTime: this.endTime });

      // plot secsNow pixels offset for the scroller
      const duration = this.endTime - this.startTime;
      const reductionFactor = (width - (segmentWidth * 2)) / duration;
      const offset = ((this.endTime - secsNow) * reductionFactor) -
        (document.documentElement.clientWidth / 2);
      const method = scroll ? 'scrollTo' : 'setPosition';
      this.boost[method]({ x: offset < 0 ? 0 : offset, y: 0 });
    },
    startInterval() {
      this.scrollToTime(true);
      if (this.intervalId == -1) {
        this.intervalId = setInterval(() => {
          this.scrollToTime();
        }, 3000);
      }
    },
    startScroll(direction) {
      this.clearInterval();
      this.scroll(scrollBy * direction);
    },
    startScrollE() {
      this.startScroll(1);
    },
    startScrollW() {
      this.startScroll(-1);
    },
    scroll(by) {
      this.clearInterval();
      let offset = this.boost.position.x * -1;
      offset = (offset > by) ? (offset += by) : 0;
      this.boost.scrollTo({ x: offset, y: 0 });
      // this.$refs['scroller-container'].scrollLeft = this.offset;
    },
    endScroll() {
      clearInterval(this.intervalScroll);
    },
    stackItems() {
      if (!this.stackedItems && window.innerWidth > window.innerHeight && window.innerWidth>=800) {
        this.stackedItems = true;

        var container = this.$refs['scroller-container-internal'];
        var previousSibling = null;
        var children = container.getElementsByClassName('scroller-item');
        var scrollerHeight = $(this.$refs['scroller-container']).height();
        var extraGroupSpacing = 100;
        var verticalGridStep = 24;
        var scrollerItemInitialYpos = children[0].offsetTop;
        var currentGroup = [];
        var gridSort = [];

        for (var i=0;i<children.length;i++) {
          var item = children[i];
          if (previousSibling) {
            
            // ######### GROUPS ALGO ################
            if ((item.offsetLeft + item.offsetWidth + extraGroupSpacing) < previousSibling.offsetLeft || i==children.length-1) {
              var previousGroupSibling = null;
              var yStep = scrollerItemInitialYpos/currentGroup.length;

              currentGroup.sort(function(a, b){  //sort group based on latitudes
                return (a.getAttribute("latitude")*1.0) - (b.getAttribute("latitude")*1.0);
              });
              // var randomGroupColor = "#"+Math.floor(Math.random()*16777215).toString(16);
              for (var groupItem of currentGroup) {
                // groupItem.style.color = randomGroupColor;
                if (previousGroupSibling) {
                  var newTop = previousGroupSibling.offsetTop - yStep;
                  groupItem.style.top = newTop+"px";
                  previousGroupSibling.style.top = (100*this.floorToNearest(previousGroupSibling.offsetTop,verticalGridStep)/scrollerHeight)+"%";
                }
                previousGroupSibling = groupItem;
              }
              previousGroupSibling.style.top = (100*this.floorToNearest(previousGroupSibling.offsetTop,verticalGridStep)/scrollerHeight)+"%";

              currentGroup = [];
            }
            if (i==1) {currentGroup.push(previousSibling);}
            currentGroup.push(item);
          }
          gridSort.push(item);
          previousSibling = item;
        }

        gridSort.sort(function(a, b){  //sort group based on row/column
          if (a.offsetTop == b.offsetTop) {
            return b.offsetLeft - a.offsetLeft;
          }
          else {
            return a.offsetTop - b.offsetTop;
          }
        });

        // fix horizontal text collisions
        for (var i=0;i<gridSort.length;i++) {
          var item = gridSort[i];
          if (previousSibling) {
            var dif = previousSibling.offsetLeft-(item.offsetLeft + item.offsetWidth);
            if (dif<0 && previousSibling.style.top == item.style.top) {
              var newleft = (item.offsetLeft + dif - 10);
              if (newleft < 10) {
                item.style.width = (item.offsetWidth+newleft)+"px";
                newleft = 10;
              }
              item.style.left = newleft+"px";
              // item.style.backgroundColor = "pink";
            }
          }
          previousSibling = item;
        }
      }
    },
  },
  mounted() {
    this.startInterval();
    this.stackItems();
    this.makeScroll();

    $(window).on("resize", this.stackItems);
  },
  beforeDestroy() {
    this.clearInterval();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Scroller.vue